import React, { useContext, useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/en-gb';
import "./rcaCustom.css";

import ChartLoaderRca from "./ChartLoaderRca";
import WaterMark from "../DashboardMain_Bus/WaterMark";

export default function RcaTable(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [dataJson, setDataJosn] = useState([])
  const [hgt, setHgt] = useState("100px")
  const getTableRes = (data) => {
    if (data.length > 0) {
      data.sort((a, b) => {
        // First, compare by _source.spnname in ascending order
        if (a._source.spnname < b._source.spnname) {
          return -1;
        } else if (a._source.spnname > b._source.spnname) {
          return 1;
        }

        // If _source.spnname are the same, compare by _source.eventdatetime in ascending order
        if (a._source.eventdatetime < b._source.eventdatetime) {
          return -1;
        } else if (a._source.eventdatetime > b._source.eventdatetime) {
          return 1;
        }

        // If both name and _source.eventdatetime are equal, maintain the original order
        return 0;
      });

      setHgt("200px")
      setDataJosn(data);
    } else {
      setHgt("100px")
      setDataJosn([]);
    }
  }

  useEffect(() => {
    if (props.filterObject.vin_no !== '') {
      fetchData({ url: API_URL_MAIN + "rca/getTableData", body: { filterdata: props.filterObject } }, getTableRes)
    }
  }, [props.filterObject])

  return (
    <div className="col-md-12 col-sm-12 col-lg-12">
      <div className="rcaBoxes mb-3" style={{ overflowY: 'scroll', height: hgt }}>
        {(isLoading) ? <ChartLoaderRca /> :
          <table className="table table-hover tableglosary m-2" style={{ width: "98%" }} align="center">
            <thead className="freezeTableHeader_bus">
              <tr>
                <th scope="col">Timestamp</th>
                <th scope="col">ECU</th>
                <th scope="col">Signal Name</th>
                <th scope="col">Description</th>
                <th scope="col">Type</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              <WaterMark />
              {
                (dataJson.length == 0) ? <tr><td colSpan={6}>No data found</td></tr> : dataJson.map((element, index) => {
                  return (<tr key={index}>
                    <td>{(element["_source"]["eventdatetime"] !== undefined) ? element["_source"]["eventdatetime"] : "-"}</td>
                    <td>{(element["_source"]["ECU"] !== undefined) ? element["_source"]["ECU"] : "-"}</td>
                    <td>{(element["_source"]["spnname"] !== undefined) ? element["_source"]["spnname"] : "-"}</td>
                    <td>{(element["_source"]["Description"] !== undefined) ? element["_source"]["Description"] : "-"}</td>
                    <td>{(element["_source"]["Type"] !== undefined) ? element["_source"]["Type"] : "-"}</td>
                    <td>{(element["_source"]["spnvalue"] !== undefined) ? element["_source"]["spnvalue"] : "-"}</td>
                  </tr>)
                })
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  );
}
